import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { m as n } from "./tss-DN0acMKN.mjs";
const r = n()({
  visuallyHidden: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    overflow: "hidden",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  }
});
function c({ ariaAtomic: e, ariaLive: a, children: t }) {
  const { classes: i } = r();
  return /* @__PURE__ */ s.jsx(
    "span",
    {
      "aria-atomic": e,
      "aria-live": a,
      className: i.visuallyHidden,
      "data-fabric-component": "ScreenReaderOnlyText",
      children: t
    }
  );
}
export {
  c as S
};
//# sourceMappingURL=screen-reader-only-text-B-XgpPEP.mjs.map
